// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class QuickBooksProduct extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Products = {
    Miscellaneous: 58
  }

  static azureTypes = ['Dumpster', 'Fuel', 'Kent County', 'Misc'];
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  azureType?: string;
  deleted?: Date;
  isVisible!: boolean;
  quickBooksAccount?: string;
  quickBooksId?: string;
  quickBooksLastSync?: Date;
  quickBooksProductService?: string;
  sETBillingCode?: string;
}

